import { render, staticRenderFns } from "./ExitFormCircles.vue?vue&type=template&id=5b5d58a2&scoped=true&"
import script from "./ExitFormCircles.vue?vue&type=script&lang=js&"
export * from "./ExitFormCircles.vue?vue&type=script&lang=js&"
import style0 from "./ExitFormCircles.vue?vue&type=style&index=0&id=5b5d58a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5d58a2",
  null
  
)

export default component.exports